import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BANNERS = [
  {
    src: 'https://customer-assets.emergentagent.com/job_genetics-modern/artifacts/nea3ezs2_IMG_20260615_084711_918.jpg',
    link: '/produkt/trenbolone-enanthate',
    alt: 'Trenbolone Enanthate 200mg/ml'
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_genetics-modern/artifacts/rwki3gfm_IMG_20260615_084712_061.jpg',
    link: '/produkt/testosterone-enanthate',
    alt: 'Testosterone Enanthate 250mg/ml'
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_genetics-modern/artifacts/jxawufu7_IMG_20260615_084712_358.jpg',
    link: '/produkt/primobolan-enanthate',
    alt: 'Primobolan Enanthate 100mg/ml'
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_genetics-modern/artifacts/2ydpa7i4_IMG_20260615_084712_428.jpg',
    link: '/sklep?cat=pep',
    alt: 'Peptydy Nowej Generacji'
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_genetics-modern/artifacts/4uwvoru9_IMG_20260615_084712_604.jpg',
    link: '/produkt/hgh',
    alt: 'Human Growth Hormone'
  }
];

const PromoBanners = () => {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(() => {
      setIdx(i => (i + 1) % BANNERS.length);
    }, 4000);
    return () => clearInterval(timerRef.current);
  }, [paused]);

  const handleClick = () => {
    navigate(BANNERS[idx].link);
  };

  return (
    <section className="bg-slate-950 border-b border-blue-900/30">
      <div
        className="relative w-full aspect-square sm:aspect-[16/12] md:aspect-[16/10] lg:aspect-[16/9] max-h-[820px] overflow-hidden cursor-pointer group"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
        aria-label={`Przejdź do produktu: ${BANNERS[idx].alt}`}
      >
        {BANNERS.map((banner, i) => (
          <img
            key={banner.src}
            src={banner.src}
            alt={banner.alt}
            loading={i === 0 ? 'eager' : 'lazy'}
            className={`absolute inset-0 w-full h-full object-contain object-center transition-opacity duration-1000 ease-in-out ${i === idx ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
            draggable={false}
            onError={(event) => { event.currentTarget.style.display = 'none'; }}
          />
        ))}

        {/* subtle gradient frame for blending */}
        <div className="absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-slate-950 to-transparent z-20 pointer-events-none" />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-slate-950/80 to-transparent z-20 pointer-events-none" />

        {/* Click hint badge */}
        <div className="absolute top-3 right-3 sm:top-5 sm:right-5 z-30 px-3 py-1.5 rounded-full bg-blue-600/90 backdrop-blur text-white text-[10px] sm:text-xs font-bold uppercase tracking-wider shadow-lg shadow-blue-900/40 opacity-90 group-hover:opacity-100 group-hover:scale-105 transition pointer-events-none">
          Zobacz produkt →
        </div>

        {/* indicator dots */}
        <div className="absolute bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5 z-30">
          {BANNERS.map((_, i) => (
            <button
              key={i}
              onClick={(e) => { e.stopPropagation(); setIdx(i); }}
              aria-label={`Banner ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${i === idx ? 'w-8 bg-blue-400' : 'w-4 bg-white/40 hover:bg-white/60'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoBanners;
